import { selectOptions } from 'store/options';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';

export default function useUsersOptions() {
  const options = useSelector(selectOptions);

  return useMemo(() => options.users, [options.users]);
}
